import { LANGUAGES } from '@/constants/languages';
import { useLanguageStore } from '@/stores/language-store';
import { useMemo } from 'react';

export function useFormatters() {
  const locale = useLanguageStore(s => s.locale);

  return useMemo(() => {
    return {
      formatCurrency: (amount: number, currencyISO: string, decimals: number = 0) =>
        new Intl.NumberFormat(LANGUAGES[locale]?.locale ?? 'es-AR', {
          style: 'currency',
          currency: currencyISO,
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        }).format(amount),

      formatNumber: (value: number, decimals: number = 0, options?: Intl.NumberFormatOptions) =>
        new Intl.NumberFormat(LANGUAGES[locale]?.locale ?? 'es-AR', {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
          ...options,
        }).format(value),

      formatPercentage: (value: number) =>
        new Intl.NumberFormat(LANGUAGES[locale]?.locale ?? 'es-AR', {
          style: 'percent',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(value),
    };
  }, [locale]);
}
